'use client';

import { PopoverArrow } from '@radix-ui/react-popover';
import type * as React from 'react';
import { DropdownMenuLabel, DropdownMenuSeparator } from '@/components/ui/dropdown-menu';
import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover';
import type { Bookmark } from '@/types/bookmarks';
import BookmarkTrigger from './BookmarkTrigger';

interface PopoverWrapperProps {
  activeBookmark: Bookmark | null;
  dataLength: number;
  children: React.ReactNode;
}

export const PopoverWrapper = ({ activeBookmark, dataLength, children }: PopoverWrapperProps) => {
  return (
    <Popover>
      <PopoverTrigger asChild>
        <BookmarkTrigger
          activeBookmark={activeBookmark}
          dataLength={dataLength}
        />
      </PopoverTrigger>
      <PopoverContent
        side='bottom'
        align='end'
        sideOffset={6}
        className='z-101 w-194.5 p-0'
      >
        <PopoverArrow className='-translate-y-px fill-white' />
        <div className='w-full'>
          <DropdownMenuLabel className='p-4'>Dina Bokmärken</DropdownMenuLabel>
          <DropdownMenuSeparator className='my-0' />
          {children}
        </div>
      </PopoverContent>
    </Popover>
  );
};
